import Main from './top/main.es6';
export default class Top {
    constructor() {
        const main = new Main();        
        this.init();
    }

    init() {
    }
}

const top = new Top();
